import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommercialContract } from 'src/app/shared/models/commercial-contract.model';

@Component({
  selector: 'app-contract',
  templateUrl: './contract.component.html',
  styleUrls: ['./contract.component.scss']
})
export class ContractComponent {

  @Input() options: CommercialContract[];
  @Input() selectedValue: CommercialContract;
  @Output() selection = new EventEmitter();
  @Output() moveBack = new EventEmitter();


  selectedOption: CommercialContract;

  constructor() {
  }

  onContractSelection(event: any) {
    this.selectedOption = this.selectedValue;
    this.selectedValue = event.option;
    this.selection.emit(event.option);
  }

  getSortedOptions() {
    if (this.options) {
      this.options.sort((a, b) => {
        if (a.name === b.name) {
          if (a.code === b.code) {
            return a.code > b.code ? 1 : -1;
          }
          return a.code > b.code ? 1 : -1;
        }
        return a.name > b.name ? 1 : -1;
      });
    }
    return this.options;
  }

}
